import React, { useEffect, useState } from "react";
import InputField from "../forms/input-field";
import TextAreaField from "../forms/textarea-field";
import PaymentAddressIcon from "../../assets/icons/admin-customer-icons/payment-address";
import AddButton, { DeleteButton } from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import AddressManagementIcon from "../../assets/icons/admin-customer-icons/address-management";
import ShippingAddressIcon from "../../assets/icons/admin-customer-icons/shipping-address";
import { Form, Formik, useFormikContext } from "formik";
import errorToast from "../helper-components/error-toast";
import { useDispatch } from "react-redux";
import { adminCustomerUpdateAddressAction } from "../../redux/actions/admin-customer-action";
import LoadingOverlay from "../helper-components/overlay-loading";
import successToast from "../helper-components/success-toast";
import { pincodeListAction, storeListAction } from "../../redux/actions/general-action";
import { useNavigate, useSearchParams } from "react-router-dom";
import { handelLabel } from "./handel-label";
import * as Yup from "yup";
import { handelEnabled } from "./handel-enabled";
import { shouldBeDisplay } from "./shouldBeDisplayed";
import SelectField from "../forms/select-field";
import { isAdmin } from "../../redux/config";

function Address({
  customerId,
  addressPay,
  addressShipping,
  page,
  disabled,
  // loading,
  // setLoading,
  setCurrentTab,
  shippingId,
  payId,
  tabs,
  customization,
}) {
  const [customData1, setcustomData1] = useState([]);
  const [customData2, setcustomData2] = useState([]);
  const [storelist, setStorelist] = useState([]);
  const [loading, setLoading] = useState(false);

  const localStorageData = JSON.parse(localStorage.getItem("customerAdmin"));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onSuccessstore = (data) => {
      setStorelist(
        data?.data?.map((item) => ({
          label: item?.concated_store_name,
          value: item?.store_id,
        }))
      );
      let a = data?.data?.map((item) => ({
        label: item?.concated_store_name,
        value: item?.store_id,
      }));
      console.log("aaaaaaaaaaaaaaaaaaa", a);
    };
    const onErrorstore = (data) => {};
    useEffect(() => {
      dispatch(storeListAction(onSuccessstore, onErrorstore));
    }, []);
  const initialValues = {
    pay: localStorageData?.addressPay ?? addressPay,
    shipping: localStorageData?.addressShipping ?? addressShipping,
  };

  const addPay = {
    cmr_id: customerId,
    // cmr_pay_address_id: payId,
    cmr_pay_address_name: "",
    cmr_pay_address_country: "",
    cmr_pay_address_state: "",
    cmr_pay_address_district: "",
    cmr_pay_address_city: "",
    cmr_pay_address_town: "",
    cmr_pay_address_street: "",
    cmr_pay_address_pincode: "",
    cmr_pay_address_address: "",
    cmr_default_address: false,
  };

  const addShipping = {
    cmr_id: customerId,
    // cmr_ship_address_id: shippingId,
    cmr_ship_address_name: "",
    cmr_ship_address_country: "",
    cmr_ship_address_state: "",
    cmr_ship_address_district: "",
    cmr_ship_address_city: "",
    cmr_ship_address_town: "",
    cmr_ship_address_street: "",
    cmr_ship_address_pincode: "",
    cmr_ship_address_address: "",
    cmr_default_address: false,
  };
  // const UpdateLocalStorage = ({ values }) => {
  //   useEffect(() => {
  //     console.log("initialValues", initialValues);
  //     localStorage.setItem("customerAdmin", JSON.stringify(values));
  //   }, [values]);
  //   return null;
  // };
  const [searchParams] = useSearchParams();
  const backto = searchParams.get("backto");
  const hasBackTo = searchParams.has("backto");
  useEffect(() => {
    return () => setLoading(false);
  }, []);
  const UpdateLocalStorage = ({ values }) => {
    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
      // if (page === "add") {
      if (isInitialRender) {
        setIsInitialRender(false);
        return; // Skip the first render
      }

      console.log("Updating localStorage with values:", values);
      try {
        const existingData =
          JSON.parse(localStorage.getItem("customerAdmin")) || {};
        const updatedData = {
          ...existingData,
          addressPay: values.pay,
          addressShipping: values.shipping,
        };
        localStorage.setItem("customerAdmin", JSON.stringify(updatedData));
      } catch (error) {
        console.error("Error updating localStorage:", error);
      }
      // }
    }, [values, isInitialRender]);

    return null;
  };
  // const handleDefaultPay = (values, setFieldValue, selectedIndex) => {
  //   const updatedPay = values.pay.map((item, index) => ({
  //     ...item,
  //     cmr_default_address: index === selectedIndex,
  //   }));
  //   console.log("default pay.................", updatedPay);
  //   setFieldValue("pay", updatedPay);
  // };

  const handleDefaultPay = (values, setFieldValue, selectedIndex) => {
    // First, update all items to set cmr_default_address appropriately
    const updatedPaySetFalse = values.pay.map((item, index) => ({
      ...item,
      cmr_default_address: false,
    }));
    const updatedPay = updatedPaySetFalse.map((item, index) => ({
      ...item,
      cmr_default_address: index === selectedIndex,
    }));

    // Find the selected item (now with cmr_default_address: true)
    const selectedItem = updatedPay[selectedIndex];

    // Create new array with selected item at top and rest below
    const reorderedPay = [
      selectedItem,
      ...updatedPay.filter((_, index) => index !== selectedIndex),
    ];
    setFieldValue("pay", reorderedPay);
  };

  const handleDefaultShipping = (values, setFieldValue, selectedIndex) => {
    // First, update all items to set cmr_default_address appropriately
    const updatedPayDefaul = values.shipping.map((item, index) => ({
      ...item,
      cmr_default_address: false,
    }));
    const updatedPay = updatedPayDefaul.map((item, index) => ({
      ...item,
      cmr_default_address: index === selectedIndex,
    }));

    // Find the selected item (now with cmr_default_address: true)
    const selectedItem = updatedPay[selectedIndex];

    // Create new array with selected item at top and rest below
    const reorderedPay = [
      selectedItem,
      ...updatedPay.filter((_, index) => index !== selectedIndex),
    ];

    console.log("default pay.................", reorderedPay);
    setFieldValue("shipping", reorderedPay);
  };

  // const handleDefaultShipping = (values, setFieldValue, selectedIndex) => {
  //   const updatedShipping = values.shipping.map((item, index) => ({
  //     ...item,
  //     cmr_default_address: index === selectedIndex,
  //   }));

  //   setFieldValue("shipping", updatedShipping);
  // };

  const handleAddPay = (values, setFieldValue) => {
    const updatedPay = [...values.pay, { ...addPay }];
    setFieldValue("pay", updatedPay);
  };

  const handleAddShipping = (values, setFieldValue) => {
    const updatedShipping = [...values.shipping, { ...addShipping }];
    setFieldValue("shipping", updatedShipping);
  };

  const handleDeletePay = (index, values, setFieldValue, length) => {
    if (length === 1) return errorToast("You need atleast one payment address");
    else if (values.pay[index].cmr_default_address === true) {
      return errorToast("Cannot delete the default address");
    } else {
      const updatedpay = values.pay.filter((_, i) => i !== index);
      setFieldValue("pay", updatedpay);
    }
  };

  const handleDeleteShipping = (index, values, setFieldValue, length) => {
    if (length === 1)
      return errorToast("You need atleast one shipping address");
    else if (values.shipping[index].cmr_default_address === true) {
      return errorToast("Cannot delete the default address");
    } else {
      const updatedShipping = values.shipping.filter((_, i) => i !== index);
      setFieldValue("shipping", updatedShipping);
    }
  };
  const onSuccess = () => {
    setLoading(false);
    successToast("Saved successfully");
    if (hasBackTo) return navigate(backto);
    else if (tabs.length > 6) {
      return setCurrentTab("Patient Info");
    }
  };
  const onError = (data) => {
    setLoading(false);
    errorToast(data.message);
  };
  const onSave = (values, { validateForm, errors }) => {
    if (loading) return;

    // Validate at least 1 default payment method
    const hasDefaultPayment = values.pay.some(
      (payment) => payment.cmr_default_address === true
    );
    if (!hasDefaultPayment) {
      errorToast("At least 1 default payment method is required");
      return;
    }

    // Validate at least 1 default shipping method
    const hasDefaultShipping = values.shipping.some(
      (shipping) => shipping.cmr_default_address === true
    );
    if (!hasDefaultShipping) {
      errorToast("At least 1 default shipping method is required");
      return;
    }

    setLoading(true);
    // let firstItem1 = values.pay[0];
    // let updatedFirstItem1 = {
    //   ...firstItem1,
    //   cmr_id: customerId,
    //   cmr_pay_address_id: payId,
    // };
    // let sendData1 = [...values.shipping];
    // sendData1[0] = updatedFirstItem1;

    //
    let sendData1 = [...values.pay];
    if (page !== "edit") {
      let firstItem1 = values.pay[0];
      let updatedFirstItem1 = {
        ...firstItem1,
        cmr_id: customerId,
        cmr_pay_address_id: payId,
      };
      sendData1[0] = updatedFirstItem1;
    }
    //
    let sendData2 = [...values.shipping];
    if (page !== "edit") {
      let firstItem2 = values.shipping[0];
      let updatedFirstItem2 = {
        ...firstItem2,
        cmr_id: customerId,
        cmr_ship_address_id: shippingId,
      };
      sendData2[0] = updatedFirstItem2;
    }
    ///
    // let firstItem2 = values.shipping[0];
    // let updatedFirstItem2 = {
    //   ...firstItem2,
    //   cmr_id: customerId,
    //   cmr_ship_address_id: shippingId,
    // };
    // let sendData2 = [...values.shipping];
    // sendData2[0] = updatedFirstItem2;
    dispatch(
      adminCustomerUpdateAddressAction(
        { shipToAddressData: values.shipping, payToAddressData: values.pay },
        onSuccess,
        onError
      )
    );
  };

  useEffect(() => {
    if (customization) {
      let data1 = customization.filter((item) => item?.label === "addressPay");
      setcustomData1(data1?.[0]?.childrenHeading);
      let data2 = customization.filter(
        (item) => item?.label === "addressShipping"
      );
      setcustomData2(data2?.[0]?.childrenHeading);
    }
  }, [customization]);
  function fetchAddressFn(inputValue, setFieldValue, index, type1, type2) {
    if (inputValue?.length === 6) {
      dispatch(
        pincodeListAction(
          inputValue,
          (response) => {
            if (response?.[0]?.Status === "Error") {
            } else {
              const firstPostOffice = response?.[0]?.PostOffice?.[0];
              // console.log(values[type], "pincode");
              setFieldValue(
                `${type1}[${index}]cmr_${type2}_address_state`,
                firstPostOffice?.State
              );
              setFieldValue(
                `${type1}[${index}]cmr_${type2}_address_district`,
                firstPostOffice?.District
              );
              setFieldValue(
                `${type1}[${index}]cmr_${type2}_address_town`,
                firstPostOffice?.Block
              );

              setFieldValue(
                `${type1}[${index}]cmr_${type2}_address_country`,
                firstPostOffice?.Country
              );
              setFieldValue(
                `${type1}[${index}]cmr_${type2}_address_city`,
                firstPostOffice?.Division
              );

              // cmr_pay_address_city: "",
              // : "",
              // cmr_pay_address_street: "",
              // cmr_pay_address_pincode: "",
              // cmr_pay_address_address: "",
            }
          },
          (data) => {
            setFieldValue(`${type1}[${index}]cmr_${type2}_address_state`, "");
            setFieldValue(
              `${type1}[${index}]cmr_${type2}_address_district`,
              ""
            );
            setFieldValue(`${type1}[${index}]cmr_${type2}_address_town`, "");
            setFieldValue(`${type1}[${index}]cmr_${type2}_address_country`, "");
            setFieldValue(`${type1}[${index}]cmr_${type2}_address_city`, "");
          }
        )
      );
    } else {
      setFieldValue(`${type1}[${index}]cmr_${type2}_address_state`, "");
      setFieldValue(`${type1}[${index}]cmr_${type2}_address_district`, "");
      setFieldValue(`${type1}[${index}]cmr_${type2}_address_town`, "");
      setFieldValue(`${type1}[${index}]cmr_${type2}_address_country`, "");
      setFieldValue(`${type1}[${index}]cmr_${type2}_address_city`, "");
    }
  }
  const pincodeRegex = /^[1-9][0-9]{5}$/;

  const validationSchema = Yup.object().shape({
    pay: Yup.array().of(
      Yup.object().shape({
        cmr_pay_address_pincode: Yup.string()
          .nullable()
          .matches(pincodeRegex, "Please enter a valid 6-digit pincode"),
      })
    ),
    shipping: Yup.array().of(
      Yup.object().shape({
        cmr_ship_address_pincode: Yup.string()
          .nullable()
          .matches(pincodeRegex, "Please enter a valid 6-digit pincode"),
      })
    ),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSave}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => (
        <Form
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); // Stop form submit
            }
          }}
        >
          {console.log(values)}
          {/* <UpdateCmrId customerId={customerId} /> */}
          {/* <UpdatePayId payId={payId} /> */}
          {/* <UpdateShippingId shippingId={shippingId} /> */}
          <LoadingOverlay isLoading={loading} />

          <UpdateLocalStorage values={values} />
          <div className="flex flex-col gap-6 mt-6">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-4">
                <div className="w-min px-[15px] py-[12px] bg-gradient-to-r from-[var(--customer-input-section-icon-from-bg)] to-[var(--customer-input-section-icon-to-bg)] rounded-xl">
                  <AddressManagementIcon />
                </div>
                <div className="flex flex-col justify-between">
                  <label className="text-[length:var(--customer-bold-fs)] font-[var(--customer-current-nav-fw)]">
                    Address Management
                  </label>
                  <label className="text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)]">
                    Add and manage different addresses for billing, shipping,
                    and other purposes
                  </label>
                </div>
              </div>
              <div className="flex gap-[6px]">
                <AddButton
                  prefixIcon={true}
                  // ref={submitRef}
                  isDisabled={disabled || page === "view"}
                  // icon={<Save size={14} />}
                  onclkFn={() => handleAddPay(values, setFieldValue)}
                  text={<span>Add Pay To</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
                <AddButton
                  prefixIcon={true}
                  // ref={submitRef}
                  isDisabled={disabled || page === "view"}
                  // icon={<Save size={14} />}
                  onclkFn={() => handleAddShipping(values, setFieldValue)}
                  text={<span>Add Ship To</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            </div>
            {values?.pay?.map((item, index) => (
              <div
                key={item.cmr_pay_address_id || `pay-${index}`}
                className=" px-[34px] pt-[34px] pb-[10px]  flex-col  rounded-2xl  bg-gradient-to-br from-[var(--customer-input-section-from-bg)] to-blue-[var(--customer-input-section-to-bg)]/0 border-[2px] border-[var(--customer-input-border-color)]"
              >
                <div className="flex  mb-6 justify-between">
                  <div className="flex flex-row gap-4">
                    <PaymentAddressIcon />
                    <div className="flex flex-col justify-between">
                      <label className="text-[length:var(--customer-sub-title-fs)] font-[var(--customer-current-nav-fw)]">
                        Pay To Address
                      </label>
                      <label className="text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)]">
                        Add and manage different addresses for billing,
                        shipping, and other purposes
                      </label>
                    </div>
                  </div>
                  <div className="flex gap-4 items-center">
                    {item.cmr_default_address ? (
                      <div className="px-5 py-[5px] rounded-full bg-[var(--customer-default-bg)] flex items-center">
                        <label className="text-[var(--customer-default-fg)] font-[var(--customer-default-fw)]">
                          Default
                        </label>
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          if (page !== "view") {
                            handleDefaultPay(values, setFieldValue, index);
                          }
                        }}
                        className="px-5 py-[5px] rounded-full bg-[var(--customer-set-default-bg)] flex items-center"
                      >
                        <label className="text-[var(--customer-set-default-fg)] font-[var(--customer-default-fw)]">
                          Set as Default
                        </label>
                      </div>
                    )}

                    <button
                      type="button"
                      // disabled={values.pay.length <= 1}
                      onClick={() => {
                        if (page !== "view") {
                          handleDeletePay(
                            index,
                            values,
                            setFieldValue,
                            values.pay.length
                          );
                        }
                      }}
                      className={`${
                        values.pay.length <= 1
                          ? "cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <DeleteIcon />
                    </button>
                  </div>
                </div>
                <div
                  className="grid gap-x-3 gap-y-0 min-w-0"
                  style={{
                    gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                  }}
                >
                  {shouldBeDisplay(
                    "cmr_pay_address_name",
                    page,
                    customData1
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`pay[${index}].cmr_pay_address_name`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_pay_address_name",
                          customData1
                        )}`}
                        allowSpecial={true}
                        label={handelLabel("cmr_pay_address_name", customData1)}
                        isDisabled={handelEnabled(
                          "cmr_pay_address_name",
                          page,
                          customData1
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_pay_address_town",
                    page,
                    customData1
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`pay[${index}].cmr_pay_address_town`}
                        allowSpecial={true}
                        placeholder={`Enter ${handelLabel(
                          "cmr_pay_address_town",
                          customData1
                        )}`}
                        label={handelLabel("cmr_pay_address_town", customData1)}
                        isDisabled={handelEnabled(
                          "cmr_pay_address_town",
                          page,
                          customData1
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_pay_address_country",
                    page,
                    customData1
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`pay[${index}].cmr_pay_address_country`}
                        allowSpecial={true}
                        placeholder={`Enter ${handelLabel(
                          "cmr_pay_address_country",
                          customData1
                        )}`}
                        label={handelLabel(
                          "cmr_pay_address_country",
                          customData1
                        )}
                        isDisabled={handelEnabled(
                          "cmr_pay_address_country",
                          page,
                          customData1
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_pay_address_street",
                    page,
                    customData1
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        allowSpecial={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`pay[${index}].cmr_pay_address_street`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_pay_address_street",
                          customData1
                        )}`}
                        label={handelLabel(
                          "cmr_pay_address_street",
                          customData1
                        )}
                        isDisabled={handelEnabled(
                          "cmr_pay_address_street",
                          page,
                          customData1
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_pay_address_state",
                    page,
                    customData1
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`pay[${index}].cmr_pay_address_state`}
                        allowSpecial={true}
                        placeholder={`Enter ${handelLabel(
                          "cmr_pay_address_state",
                          customData1
                        )}`}
                        label={handelLabel(
                          "cmr_pay_address_state",
                          customData1
                        )}
                        isDisabled={handelEnabled(
                          "cmr_pay_address_state",
                          page,
                          customData1
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_pay_address_pincode",
                    page,
                    customData1
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        maxLength={6}
                        
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`pay[${index}].cmr_pay_address_pincode`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_pay_address_pincode",
                          customData1
                        )}`}
                        label={handelLabel(
                          "cmr_pay_address_pincode",
                          customData1
                        )}
                        isDisabled={handelEnabled(
                          "cmr_pay_address_pincode",
                          page,
                          customData1
                        )}
                        type="number"
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        handleChange={(e) => {
                          fetchAddressFn(
                            e?.target?.value,
                            setFieldValue,
                            index,
                            "pay",
                            "pay"
                          );
                        }}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_pay_address_district",
                    page,
                    customData1
                  ) && (
                    <div className="col-span-1">
                      <InputField
                      allowSpecial={true}
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`pay[${index}].cmr_pay_address_district`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_pay_address_district",
                          customData1
                        )}`}
                        label={handelLabel(
                          "cmr_pay_address_district",
                          customData1
                        )}
                        isDisabled={handelEnabled(
                          "cmr_pay_address_district",
                          page,
                          customData1
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_pay_address_city",
                    page,
                    customData1
                  ) && (
                    <div className="col-span-1">
                      <InputField
                      allowSpecial={true}
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`pay[${index}].cmr_pay_address_city`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_pay_address_city",
                          customData1
                        )}`}
                        label={handelLabel("cmr_pay_address_city", customData1)}
                        isDisabled={handelEnabled(
                          "cmr_pay_address_city",
                          page,
                          customData1
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                </div>

                {shouldBeDisplay(
                  "cmr_pay_address_address",
                  page,
                  customData1
                ) && (
                  <div className="flex flex-col gap-2">
                    <label className=" text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                      {handelLabel("cmr_pay_address_address", customData1)}
                      (max 250 Characters)
                    </label>
                    <TextAreaField
                      maxLength={250}
                      name={`pay[${index}].cmr_pay_address_address`}
                      placeholder={`Enter ${handelLabel(
                        "cmr_pay_address_address",
                        customData1
                      )}`}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      parentClass="flex  flex-col gap-2 w-full align-end "
                      label=""
                      isDisabled={handelEnabled(
                        "cmr_pay_address_address",
                        page,
                        customData1
                      )}
                      defaultInputClass={` min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                      containerClass="flex flex-col gap-2 w-full "
                    />
                  </div>
                )}
                <div
                  className="grid gap-x-3 gap-y-0 min-w-0"
                  style={{
                    gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                  }}
                >
                  {shouldBeDisplay(
                    "cmr_pay_pan",
                    page,
                    customData1
                  ) && (
                    <div className="col-span-1">
                      <InputField
                      allowSpecial={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`pay[${index}].cmr_pay_pan`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_pay_pan",
                          customData1
                        )}`}
                        label={handelLabel("cmr_pay_pan", customData1)}
                        isDisabled={handelEnabled(
                          "cmr_pay_pan",
                          page,
                          customData1
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] `}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay("cmr_pay_gst", page, customData1) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`pay[${index}].cmr_pay_gst`}
                        placeholder={`Enter ${handelLabel("cmr_pay_gst", customData1)}`}
                        label={handelLabel("cmr_pay_gst", customData1)}
                        isDisabled={handelEnabled("cmr_pay_gst", page, customData1)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay("cmr_pay_fssai_no", page, customData1) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`pay[${index}].cmr_pay_fssai_no`}
                        placeholder={`Enter ${handelLabel("cmr_pay_fssai_no", customData1)}`}
                        label={handelLabel("cmr_pay_fssai_no", customData1)}
                        isDisabled={handelEnabled("cmr_pay_fssai_no", page, customData1)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay("cmr_pay_dl_no_20_20b", page, customData1) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`pay[${index}].cmr_pay_dl_no_20_20b`}
                        placeholder={`Enter ${handelLabel("cmr_pay_dl_no_20_20b", customData1)}`}
                        label={handelLabel("cmr_pay_dl_no_20_20b", customData1)}
                        isDisabled={handelEnabled("cmr_pay_dl_no_20_20b", page, customData1)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay("cmr_pay_dl_no_21_21b", page, customData1) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`pay[${index}].cmr_pay_dl_no_21_21b`}
                        placeholder={`Enter ${handelLabel("cmr_pay_dl_no_21_21b", customData1)}`}
                        label={handelLabel("cmr_pay_dl_no_21_21b", customData1)}
                        isDisabled={handelEnabled("cmr_pay_dl_no_21_21b", page, customData1)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay("cmr_pay_dl_no_21c", page, customData1) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`pay[${index}].cmr_pay_dl_no_21c`}
                        placeholder={`Enter ${handelLabel("cmr_pay_dl_no_21c", customData1)}`}
                        label={handelLabel("cmr_pay_dl_no_21c", customData1)}
                        isDisabled={handelEnabled("cmr_pay_dl_no_21c", page, customData1)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay("cmr_pay_dl_no_21f", page, customData1) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`pay[${index}].cmr_pay_dl_no_21f`}
                        placeholder={`Enter ${handelLabel("cmr_pay_dl_no_21f", customData1)}`}
                        label={handelLabel("cmr_pay_dl_no_21f", customData1)}
                        isDisabled={handelEnabled("cmr_pay_dl_no_21f", page, customData1)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
            {values?.shipping?.map((item, index) => (
              <div className=" px-[34px] pt-[34px] pb-[10px] flex-col  rounded-2xl bg-gradient-to-br from-[var(--customer-input-section-from-bg)] to-blue-[var(--customer-input-section-to-bg)]/0 border-[2px] border-[var(--customer-input-border-color)]">
                <div className="flex  mb-6 justify-between">
                  <div className="flex flex-row gap-4">
                    <ShippingAddressIcon />
                    <div className="flex flex-col justify-between">
                      <label className="text-[length:var(--customer-sub-title-fs)] font-[var(--customer-current-nav-fw)]">
                        Ship To Addresses
                      </label>
                      <label className="text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)]">
                        Delivery and shipping addresses
                      </label>
                    </div>
                  </div>
                  <div className="flex gap-4 items-center">
                    {item.cmr_default_address ? (
                      <div className="px-5 py-[5px] rounded-full bg-[var(--customer-default-bg)] flex items-center">
                        <label className="text-[var(--customer-default-fg)] font-[var(--customer-default-fw)]">
                          Default
                        </label>
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          if (page !== "view") {
                            handleDefaultShipping(values, setFieldValue, index);
                          }
                        }}
                        className="px-5 py-[5px] rounded-full bg-[var(--customer-set-default-bg)] flex items-center"
                      >
                        <label className="text-[var(--customer-set-default-fg)] font-[var(--customer-default-fw)]">
                          Set as Default
                        </label>
                      </div>
                    )}
                    <button
                      type="button"
                      // disabled={values.shipping.length <= 1}
                      onClick={() => {
                        if (page !== "view") {
                          handleDeleteShipping(
                            index,
                            values,
                            setFieldValue,
                            values.shipping.length
                          );
                        }
                      }}
                      className={`${
                        values.shipping.length <= 1
                          ? "cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <DeleteIcon />
                    </button>
                  </div>
                </div>
                <div
                  className="grid gap-x-3 gap-y-0 min-w-0"
                  style={{
                    gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                  }}
                >
                  {shouldBeDisplay(
                    "cmr_ship_address_name",
                    page,
                    customData2
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        allowSpecial={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`shipping[${index}].cmr_ship_address_name`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_ship_address_name",
                          customData2
                        )}`}
                        label={handelLabel(
                          "cmr_ship_address_name",
                          customData2
                        )}
                        isDisabled={handelEnabled(
                          "cmr_ship_address_name",
                          page,
                          customData2
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay(
                    "cmr_ship_address_town",
                    page,
                    customData2
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`shipping[${index}].cmr_ship_address_town`}
                        allowSpecial={true}
                        placeholder={`Enter ${handelLabel(
                          "cmr_ship_address_town",
                          customData2
                        )}`}
                        label={handelLabel(
                          "cmr_ship_address_town",
                          customData2
                        )}
                        isDisabled={handelEnabled(
                          "cmr_ship_address_town",
                          page,
                          customData2
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay(
                    "cmr_ship_address_country",
                    page,
                    customData2
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        allowSpecial={true}
                        name={`shipping[${index}].cmr_ship_address_country`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_ship_address_country",
                          customData2
                        )}`}
                        label={handelLabel(
                          "cmr_ship_address_country",
                          customData2
                        )}
                        isDisabled={handelEnabled(
                          "cmr_ship_address_country",
                          page,
                          customData2
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}    
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_ship_address_street",
                    page,
                    customData2
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`shipping[${index}].cmr_ship_address_street`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_ship_address_street",
                          customData2
                        )}`}
                        allowSpecial={true}
                        label={handelLabel(
                          "cmr_ship_address_street",
                          customData2
                        )}
                        isDisabled={handelEnabled(
                          "cmr_ship_address_street",
                          page,
                          customData2
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_ship_address_state",
                    page,
                    customData2
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`shipping[${index}].cmr_ship_address_state`}
                        allowSpecial={true}
                        placeholder={`Enter ${handelLabel(
                          "cmr_ship_address_state",
                          customData2
                        )}`}
                        label={handelLabel(
                          "cmr_ship_address_state",
                          customData2
                        )}
                        isDisabled={handelEnabled(
                          "cmr_ship_address_state",
                          page,
                          customData2
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_ship_address_pincode",
                    page,
                    customData2
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        type="number"
                        // isRequired={true}
                        maxLength={6}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`shipping[${index}].cmr_ship_address_pincode`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_ship_address_pincode",
                          customData2
                        )}`}
                        label={handelLabel(
                          "cmr_ship_address_pincode",
                          customData2
                        )}
                        isDisabled={handelEnabled(
                          "cmr_ship_address_pincode",
                          page,
                          customData2
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        handleChange={(e) => {
                          fetchAddressFn(
                            e?.target?.value,
                            setFieldValue,
                            index,
                            "shipping",
                            "ship"
                          );
                        }}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_ship_address_district",
                    page,
                    customData2
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`shipping[${index}].cmr_ship_address_district`}
                        allowSpecial={true}
                        placeholder={`Enter ${handelLabel(
                          "cmr_ship_address_district",
                          customData2
                        )}`}
                        label={handelLabel(
                          "cmr_ship_address_district",
                          customData2
                        )}
                        isDisabled={handelEnabled(
                          "cmr_ship_address_district",
                          page,
                          customData2
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_ship_address_city",
                    page,
                    customData2
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`shipping[${index}].cmr_ship_address_city`}
                        allowSpecial={true}
                        placeholder={`Enter ${handelLabel(
                          "cmr_ship_address_city",
                          customData2
                        )}`}
                        label={handelLabel(
                          "cmr_ship_address_city",
                          customData2
                        )}
                        isDisabled={handelEnabled(
                          "cmr_ship_address_city",
                          page,
                          customData2
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay("store_id",page,
                    customData2)&&isAdmin && (
                  <div className="col-span-1">
                    <SelectField
                      defaultValue={storelist?.find(
                        (option) => option?.value === values?.shipping[index]?.store_id
                      )}
                      // label={handelLabel("store_id")}
                      label={"Store Mapping"}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      general_color="true"
                      borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                      isContainer={true}
                      containerClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      parentClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      // isDisabled={handelenabled("store_id")}
                      isDisabled={disabled}
                      // errMsgContainerClass="hidden"
                      id={`shipping[${index}].store_id`}
                      // placeholder={`Select ${handelLabel("store_id")}`}
                      placeholder="Select Store id"
                      options={storelist}
                      name={`shipping[${index}].store_id`}
                      isSearchable={true}
                      // isRequired={true}
                    />
                  </div>
                )}
                </div>
                {/* {shouldBeDisplay(
                  "cmr_ship_address_address",
                  page,
                  customData2
                ) && (
                  <div className="flex flex-col gap-2">
                    <label className=" text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                      {handelLabel("cmr_ship_address_address", customData2)}
                    </label>
                    <TextAreaField
                      isRequired={true}
                      // labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      // parentClass="flex  flex-col gap-2 w-full align-end "
                      parentClass="flex flex-col gap-2 w-full "
                      name={`shipping[${index}].cmr_ship_address_address`}
                      placeholder={`Enter ${handelLabel(
                        "cmr_ship_address_address",
                        customData2
                      )}`}
                      label=""
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      isDisabled={handelEnabled(
                        "cmr_ship_address_address",
                        page,
                        customData2
                      )}
                      defaultInputClass={` min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                      containerClass="flex flex-col gap-2 w-full "
                    />
                  </div>
                )} */}

                {shouldBeDisplay(
                  "cmr_ship_address_address",
                  page,
                  customData2
                ) && (
                  <div className="flex flex-col gap-2">
                    <label className=" text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                      {handelLabel("cmr_ship_address_address", customData2)}{" "}
                      (max 250 Characters)
                    </label>
                    <TextAreaField
                      maxLength={250}
                      // isRequired={true}
                      // labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      // parentClass="flex  flex-col gap-2 w-full align-end "
                      parentClass="flex flex-col gap-2 w-full "
                      name={`shipping[${index}].cmr_ship_address_address`}
                      placeholder={`Enter ${handelLabel(
                        "cmr_ship_address_address",
                        customData2
                      )}`}
                      label=""
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      isDisabled={handelEnabled(
                        "cmr_ship_address_address",
                        page,
                        customData2
                      )}
                      defaultInputClass={` min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                      containerClass="flex flex-col gap-2 w-full "
                    />
                  </div>
                )}
                <div
                  className="grid gap-x-3 gap-y-0 min-w-0"
                  style={{
                    gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                  }}
                >
                  {/* ---------- cmr_ship_pan ---------- */}
                  {shouldBeDisplay("cmr_ship_pan", page, customData2) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`shipping[${index}].cmr_ship_pan`}
                        placeholder={`Enter ${handelLabel("cmr_ship_pan", customData2)}`}
                        label={handelLabel("cmr_ship_pan", customData2)}
                        isDisabled={handelEnabled("cmr_ship_pan", page, customData2)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {/* ---------- cmr_ship_gst ---------- */}
                  {shouldBeDisplay("cmr_ship_gst", page, customData2) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`shipping[${index}].cmr_ship_gst`}
                        placeholder={`Enter ${handelLabel("cmr_ship_gst", customData2)}`}
                        label={handelLabel("cmr_ship_gst", customData2)}
                        isDisabled={handelEnabled("cmr_ship_gst", page, customData2)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {/* ---------- cmr_ship_fssai_no ---------- */}
                  {shouldBeDisplay("cmr_ship_fssai_no", page, customData2) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`shipping[${index}].cmr_ship_fssai_no`}
                        placeholder={`Enter ${handelLabel("cmr_ship_fssai_no", customData2)}`}
                        label={handelLabel("cmr_ship_fssai_no", customData2)}
                        isDisabled={handelEnabled("cmr_ship_fssai_no", page, customData2)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {/* ---------- cmr_ship_dl_no_20_20b ---------- */}
                  {shouldBeDisplay("cmr_ship_dl_no_20_20b", page, customData2) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`shipping[${index}].cmr_ship_dl_no_20_20b`}
                        placeholder={`Enter ${handelLabel("cmr_ship_dl_no_20_20b", customData2)}`}
                        label={handelLabel("cmr_ship_dl_no_20_20b", customData2)}
                        isDisabled={handelEnabled("cmr_ship_dl_no_20_20b", page, customData2)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {/* ---------- cmr_ship_dl_no_21_21b ---------- */}
                  {shouldBeDisplay("cmr_ship_dl_no_21_21b", page, customData2) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`shipping[${index}].cmr_ship_dl_no_21_21b`}
                        placeholder={`Enter ${handelLabel("cmr_ship_dl_no_21_21b", customData2)}`}
                        label={handelLabel("cmr_ship_dl_no_21_21b", customData2)}
                        isDisabled={handelEnabled("cmr_ship_dl_no_21_21b", page, customData2)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {/* ---------- cmr_ship_dl_no_21c ---------- */}
                  {shouldBeDisplay("cmr_ship_dl_no_21c", page, customData2) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`shipping[${index}].cmr_ship_dl_no_21c`}
                        placeholder={`Enter ${handelLabel("cmr_ship_dl_no_21c", customData2)}`}
                        label={handelLabel("cmr_ship_dl_no_21c", customData2)}
                        isDisabled={handelEnabled("cmr_ship_dl_no_21c", page, customData2)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {/* ---------- cmr_ship_dl_no_21f ---------- */}
                  {shouldBeDisplay("cmr_ship_dl_no_21f", page, customData2) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`shipping[${index}].cmr_ship_dl_no_21f`}
                        placeholder={`Enter ${handelLabel("cmr_ship_dl_no_21f", customData2)}`}
                        label={handelLabel("cmr_ship_dl_no_21f", customData2)}
                        isDisabled={handelEnabled("cmr_ship_dl_no_21f", page, customData2)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                </div>
              </div>
            ))}
          </div>
          {page !== "view" && (
            <div
              style={{
                bottom: "0",
              }}
              className="flex justify-between  sticky bg-white py-4  "
            >
              <AddButton
                prefixIcon={false}
                // ref={submitRef}
                isDisabled={disabled}
                // icon={<Save size={14} />}
                onclkFn={async () => navigate("/admin/customer")}
                text={<span>Cancel</span>}
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                type="button"
              />
              <div className="flex flex-row gap-3">
                {hasBackTo && (
                  <AddButton
                    prefixIcon={false}
                    // ref={submitRef}
                    isDisabled={disabled || page === "view"}
                    // icon={<Save size={14} />}
                    onclkFn={() => navigate(backto)}
                    text={<span>Back</span>}
                    className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                    type="button"
                  />
                )}
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled || page === "view"}
                  // icon={<Save size={14} />}
                  // onclkFn={onSave}
                  text={<span>Save</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="submit"
                />
              </div>
            </div>
          )}
          {page == "view" && (
            <div
              style={{
                bottom: "0",
              }}
              className="flex justify-end sticky bg-white py-4  "
            >
              <AddButton
                prefixIcon={false}
                // ref={submitRef}
                // isDisabled={false}
                // icon={<Save size={14} />}
                onclkFn={() =>
                  navigate(`/edit-customer-admin/${customerId}`, {
                    state: { tab: "Address" },
                  })
                }
                text={<span>Edit</span>}
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                type="button"
              />
            </div>
          )}
        </Form>
      )}
    </Formik>
  );
}

export default Address;

function UpdateCmrId({ customerId }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (!Object.hasOwn(values.pay[0], "cmr_id")) {
      setFieldValue("pay[0].cmr_id", customerId);
    }
    if (!Object.hasOwn(values.shipping[0], "cmr_id")) {
      setFieldValue("shipping[0].cmr_id", customerId);
    }
  }, [customerId, setFieldValue]);

  return null;
}

function UpdatePayId({ payId }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (
      values.pay?.[0] &&
      !Object.hasOwn(values.pay[0], "cmr_pay_address_id")
    ) {
      setFieldValue("pay[0].cmr_pay_address_id", payId);
    }
  }, [payId, setFieldValue]);

  return null;
}

function UpdateShippingId({ shippingId }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (
      values.shipping?.[0] &&
      !Object.hasOwn(values.shipping[0], "cmr_pay_address_state")
    ) {
      setFieldValue("shipping[0].cmr_ship_address_id", shippingId);
    }
  }, [shippingId, setFieldValue]);

  return null;
}
